import useResolution from '@hooks/useResolution'
import BackgroundImage from '@components/common/background-image'
import { staticFile } from '@common/utils'
import { FastlyImage } from '@components/common/image'

const IMAGE_PATH = '/images/student-projects-page/first-fold/'

const FirstFold = () => {
  const {
    sizes: { sm, md },
  } = useResolution()

  const changeBg =
    sm || md
      ? ' linear-gradient(82.95deg, #BF3240 -6.56%, #7E36D9 122.43%), #FF5A43'
      : 'linear-gradient(287.41deg, #BF3240 -8.7%, #B73252 24.1%, #7E36D9 100%), #FF5A43'

  return (
    <div
      style={{
        background: changeBg,
      }}
      className="md:rounded-b-2xl"
    >
      <BackgroundImage
        image={`${IMAGE_PATH}left.png`}
        top={-2}
        left={-3}
        width={18}
        zIndex={1}
        alt="codingal student projects"
      />
      <div className="relative container mx-auto overflow-hidden md:block">
        <img
          src={staticFile(`${IMAGE_PATH}mobile-top-polygon.webp`)}
          className="md:hidden absolute w-64 right-0 -top-5"
          alt="codingal student projects"
          loading="lazy"
        />
        <BackgroundImage
          image={`${IMAGE_PATH}Polygon-1.webm`}
          top={-20}
          right={0}
          width={50}
          zIndex={1}
          alt="codingal student projects"
        />
        <div className="flex justify-center items-center">
          <div className="z-10 md:pl-32 w-148 pt-20">
            <h1 className="text-white text-center md:text-left text-4xl md:text-6xl font-600 leading-tight">
              Student projects
            </h1>
            <p className="text-white text-xl text-center px-2 md:px-0 pt-3 md:text-2xl md:text-left font-300 md:font-400 leading-tight">
              All the amazing apps, websites and games that our students have
              created in one place
            </p>
          </div>
          <div className="hidden md:block w-128 py-4">
            <FastlyImage
              src={`${IMAGE_PATH}hero-image.webp`}
              alt="codingal student projects"
              width={512}
              height={312}
            />
          </div>
        </div>
        <div className="md:hidden pt-12 text-center">
          <FastlyImage
            src={`${IMAGE_PATH}hero-image-phone.webp`}
            alt="codingal student projects"
            width={375}
            height={296}
          />
        </div>
      </div>
    </div>
  )
}

export default FirstFold
